/* JAYKEI related products: masked heading reveal on scroll-in, plus the rail
   arrows. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function intro(root) {
    if (root.dataset.intro === 'ready') return;
    if (reduced || !('IntersectionObserver' in window)) return;   // CSS leaves it visible
    root.dataset.intro = 'ready';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }

  /* One card per press. The arrows only appear once the rail is known to
     overflow, and each one switches off at its end of the travel. */
  function nav(root) {
    var tray = root.querySelector('[data-rel-tray]');
    var rail = root.querySelector('[data-rel-rail]');
    if (!tray || !rail || tray.dataset.nav === 'on') return;
    var prev = root.querySelector('[data-rel-prev]');
    var next = root.querySelector('[data-rel-next]');
    if (!prev || !next) return;
    tray.dataset.nav = 'on';

    function step() {
      var card = rail.querySelector('.jk-rel__card');
      if (!card) return Math.round(rail.clientWidth * 0.8);
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }

    /* Measured from the card edges, not from scrollLeft: the rail carries 16px
       of padding and snaps to it, so it rests at scrollLeft 16 rather than 0
       and a `scrollLeft <= 1` test never saw the start. */
    function sync() {
      var cards = rail.querySelectorAll('.jk-rel__card');
      tray.classList.toggle('has-nav', rail.scrollWidth - rail.clientWidth > 2);
      if (!cards.length) { prev.disabled = next.disabled = true; return; }
      var box = rail.getBoundingClientRect();
      prev.disabled = cards[0].getBoundingClientRect().left >= box.left - 1;
      // The last child, not the last card, so the arrow still reaches Shop all.
      next.disabled = rail.lastElementChild.getBoundingClientRect().right <= box.right + 1;
    }

    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Cards carry lazy images, so the rail's width is not final at DOMContentLoaded.
    window.addEventListener('load', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('[data-jk-rel]').forEach(function (root) {
      intro(root);
      nav(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
